import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import {Grid} from '@mui/material';
import {useState} from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  p: '24px 20px 24px',
  width: '315px',
  fontFamily: 'dana-bold',
  background: '#F5F5F5',
  border: '1px solid #FFFFFF',
  boxShadow: ' 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #FFFFFF',
  borderRadius: '16px',

  textAlign: 'center',
  color: '#707070',
};
const btnStyle = {
  fontFamily: 'dana-bold',
  fontSize: '16px',
  width: '129px',
  height: '40px',
  background: '#FFFFFF',
  border: '1px solid #FFFFFF',
  boxShadow:
    '-10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4)',
  borderRadius: '98px',
};

export default function ExitModal(props) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <span onClick={handleOpen}>{props.children}</span>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        hideBackdrop>
        <>
          <Backdrop
            sx={{
              background: 'rgba(216, 216, 216, 0.3)',
              backdropFilter: 'blur(6.7957px)',
              transition: 'ease-in-out 0.2s !important',
            }}
            open={open}
            onClick={() => setOpen(false)}
          />
          <Fade in={open}>
            <Grid container sx={style}>
              <p>آیا مطمئنید می خواهید از اپلیکیشن خارج شوید ؟</p>
              <Grid container xs={12} justifyContent='space-between' mt='15px'>
                <Button sx={btnStyle} onClick={props.logout}>
                  <span style={{color: '#D81D5D'}}>بله</span>
                </Button>
                <Button sx={btnStyle} onClick={handleClose}>
                  <span style={{color: '#6F4D9F'}}>خیر</span>
                </Button>
              </Grid>
            </Grid>
          </Fade>
        </>
      </Modal>
    </div>
  );
}
